module.exports = __webpack_public_path__ + "static/img/yf_06.3137318.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yf/yf_06.jpg
// module id = 9o9V
// module chunks = 1